const technicalEvents = [
	{
		img: "/assets/code.webp",
		title: "Coding",
		subtitle:
			"Get a chance to showcase your coding skills by registering yourself at our coding event and be the top in coding to get exciting prize",
	},
	{
		img: "/assets/debug.webp",
		title: "Operation Debug T22",
		subtitle:
			"A wave of bugs has invaded and corrupted our most valuable programmes So we have launched an operation to counter this invasion and we Invite you to join us ",
	},
	{
		img: "/assets/web.webp",
		title: "Web page",
		subtitle: "Front-end Web Development Contest",
	},
	{
		img: "/assets/proj.webp",
		title: "TechNovation",
		subtitle:
			"Are you lacking a platform for showcasing your innovative ideas  Boom Time has come again to present your ideas at greater level others the innovator within you.",
	},
	{
		img: "/assets/algo.webp",
		title: "CrackAlgos",
		subtitle:
			"Are you willing to crack some algos? then we’ve something for you, We’ve CrackAlgos Event for you.If you are assuming that you’re good at solving algorithms then come and show your goodness here in CrackAlgos Event",
	},
];

export default technicalEvents;
